import Request from "@/services/request/index";

export const page = (params) => {
  return Request.get({
    url: "/exam/info/app-page",
    method: "get",
    params,
  });
};

export const get = (params) => {
  return Request.get({
    url: "/exam/info/app-get",
    params,
  });
};

// 考生考试列表（可报名 + 已报名）
export const getAppExamList = () => {
  return Request.get({
    url: "/exam/info/app-exam-list",
  });
};
// 获得指定考试的操作指南（考生端）
export const getGuide = (params) => {
  return Request.get({
    url: "/exam/guide/app-get",
    params,
  });
};
// 获得当前考生可打印准考证列表
export const getPrintList = (params) => {
  return Request.get({
    url: "/exam/registration/ticket-list",
    params,
  });
};

// 下载准考证
export const downloadTicket = (params) => {
  return Request.download({
    url: "/exam/registration/download-ticket",
    params,
  });
};
// 获得当前考生可打印心理测试准考证列表（仅在心理测试准考证已发布时返回）
export const getPsyPrintList = (params) => {
  return Request.get({
    url: "/exam/registration/psy-ticket-list",
    params,
  });
};

// 下载心理测试准考证
export const downloadPsyTicket = (params) => {
  return Request.download({
    url: "/exam/registration/download-psy-ticket",
    params,
  });
};
// 获得当前考生可打印报名资格审核登记表列表
export const getQualificationReviewFormList = (params) => {
  return Request.get({
    url: "/exam/registration/qualification-review-form-list",
    params,
  });
};
// 下载当前考生报名资格审核登记表
export const downloadQualificationReviewForm = (params) => {
  return Request.download({
    url: "/exam/registration/download-qualification-review-form",
    params,
  });
};
